import React from "react";
import "./SubjectHeader.css";
import { getQualificationTitle } from "../utils/utils";
import {useSubject} from '../context/SubjectContext';

const SubjectHeader = ({ selectedSubject, selectedSubjectCode }) => {
  const { subjectData , subjects} = useSubject();
  return (
    <div>
      <div id="pageMainContent ">
        <div className="xcontainer">
          <section className="section mt-0 py-0">
            <div className="pt-2 subject-header-fixed">
              <p className="is-size-6 has-text-weight-bold">
                 {getQualificationTitle(subjects, subjectData?.selectedSubjectId)}
              </p>
              <h1 className="title is-2 mb-0">
                {selectedSubject}{" "}
                <span className="is-size-6 has-text-weight-normal">
                  {selectedSubjectCode || (selectedSubject === "Oracy" ? "H055" : "")} {/* Added a fallback for Oracy when selectedSubjectCode is empty */}
                </span>
              </h1>
              <p className="xbox xnotification is-info mt-0">Dashboard</p>
              <hr className="mb-0 mt-2" />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SubjectHeader;
